import type { ImgHTMLAttributes } from 'react';

// Images remain static files or Shopify CDN URLs; no image server is required.
export default function Image({
  fill,
  priority,
  preload,
  style,
  ...props
}: ImgHTMLAttributes<HTMLImageElement> & {
  fill?: boolean;
  priority?: boolean;
  preload?: boolean;
}) {
  return (
    <img
      {...props}
      loading={priority || preload ? 'eager' : (props.loading ?? 'lazy')}
      fetchPriority={priority || preload ? 'high' : undefined}
      style={{
        ...(fill
          ? ({
              position: 'absolute',
              inset: 0,
              width: '100%',
              height: '100%',
            } as const)
          : {}),
        ...style,
      }}
    />
  );
}
